import useSWR from 'swr';
import { MatchDetailItemFragment } from '@amf/shared/types/graphql';

const MATCH_LIVE_RELOAD_TIME = 30 * 1000;

function getKey(id: string | null) {
  if (!id) return null;
  return `/api/match/detail?id=${id}`;
}

function useMatch(
  id: string | null = null,
  live: boolean = false,
  refreshInterval: number = MATCH_LIVE_RELOAD_TIME,
) {
  const { data, mutate } = useSWR<MatchDetailItemFragment | null>(getKey(id), {
    refreshInterval: live ? refreshInterval : 0,
  });

  return {
    match: data ?? null,
    mutate,
  };
}

export default useMatch;
